import React, { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export function useOnline() {
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  return online;
}

export default function OfflineBanner() {
  const online = useOnline();
  if (online) return null;
  return (
    <div data-testid="offline-banner" className="fixed inset-x-0 top-0 z-[100] flex items-center justify-center gap-2 bg-[#8B3A3A] px-4 py-2 text-xs font-semibold text-white">
      <WifiOff className="h-3.5 w-3.5" /> You're offline — actions that need a connection are paused. Private documents are never shown from cache.
    </div>
  );
}
